export default function sortArray<List>(
  dataSet: List[],
  naturalSortDirection: "ASC" | "DESC",
  wantedSortDirection: "ASC" | "DESC",
) {
  if (naturalSortDirection === "ASC") {
    if (wantedSortDirection === "DESC") {
      return dataSet.slice().reverse();
    }
    return dataSet;
  }
  if (naturalSortDirection === "DESC") {
    if (wantedSortDirection === "ASC") {
      return dataSet.slice().reverse();
    }
  }
  return dataSet.slice();
}
